
import CardWrapper from "../../../../components/wrapper/card/CardWrapper.tsx";
import { IDeviceStateControllerReturn } from "../../../../../../../commonreact/main/services/devicestate/DeviceStateController.ts";
import { useTranslation } from "react-i18next";
import CommonCSSSerivce from "../../../../../../../commonreact/main/services/CommonCSSSerivce.ts";
import { images, webVideos } from "../../../../../../../Media.ts";
import { Globals } from "../../../../../logic/services/Globals.ts";
import AppCSSService from "../../../../services/AppCSSService.ts";
import AppSVGStore from "../../../../services/AppSVGStore.tsx";

import { VideoController } from "../../../../controllers/VideoController.ts";
import CommonReactGUIElementsFactory from "../../../../../../../commonreact/main/factorys/guielements/CommonReactGUIElementsFactory.tsx";
import { ToolTip } from "../../../../../../../commonreact/main/tooltip/ToolTip.tsx";
import { EBrowser } from "../../../../../../../commonreact/main/services/devicestate/DeviceStateEnums.ts";
import { ELng } from "../../../../../../../language/main/LanguageKeysEnums.ts";

interface IProps {
  dsc: IDeviceStateControllerReturn;
  ef: CommonReactGUIElementsFactory;
}

export const WebsitePromoVideoCard: React.FC<IProps> = (props): JSX.Element => {
  
  const { t } = useTranslation();
  
  //init controllers
  //const vc = VideoController({})
  const r = 960/540
  const height= props.dsc.screenHeight()
  //init services
  const supportedBrowsers = [EBrowser.GoogleChrome, EBrowser.Edge, EBrowser.Brave, EBrowser.Opera]
  const isSupportedBrowser = props.dsc.currentBrowserIsOneOfGivenBrowsers(supportedBrowsers)

  
  return (
    <CardWrapper
    dsc={props.dsc}
    header={<h1> {t(ELng.website_header.valueOf())} </h1>}
    hideHeaderLine
  >
    <div className="flex flex-col mt-0">
      <div className={`flex ${props.dsc.medium ? "flex-col" : "flex-row"}`}>
        <div className={`${props.dsc.medium ? "w-full" : "w-5/12"} mr-4 mb-8`}>
            <h2> {t(ELng.website_promo_intro_header.valueOf())} </h2>
            <p> {t(ELng.website_promo_intro_desc.valueOf())} </p>
          <div className={`flex flex-row`}>
            <ToolTip content={<div className="text-lg flex flex-col">
                <p> {t(ELng.website_promo_mobiles_tooltip_header.valueOf())} </p>
              <div> {supportedBrowsers.map((it, idx) => it.valueOf() + " ")} </div>
            </div>}
              children={<>{AppSVGStore.getSupportedBrowseres({ size: 40 })}</>} pos={[0, -7]}
            />
          </div>
          <div className="pt-8">
            <h2>{t(ELng.website_promo_mobiles_header.valueOf())}</h2>
            <p>{t(ELng.website_promo_mobiles_desc.valueOf())}</p>
          </div>
        </div>

        <div className={`
           ${(props.dsc.isMobile) ? "w-full" : (props.dsc.medium ? "w-full" : "w-7/12")}
           ${(props.dsc.isMobileLandscape) ? `h-${height}` : ("h-full")}`}>
  
          <div className="m-auto relative ">
            <img
              className={`rounded-lg m-auto`}
              width={height * r}

              src={images.promo}
            ></img>
          </div>
        </div>
      </div>
    </div>

    <div className={`whitespace-nowrap mt-4 overflow-visible w-full`}>
      {props.ef.getButtonType1({
        classNameFrame: props.dsc.medium?"w-full":"w-[35rem]",
        classNameBaseFrame: "",
        classNameInput: CommonCSSSerivce.buttonwhite + " "+(isSupportedBrowser?AppCSSService.onItemHover:"[&&]:cursor-default [&&]:hover:bg-white")  + " w-full",
        caption: () => <>
          <div className="flex items-center">
            <div className="p-2 pb-2 flex flex-row">
              <img className={"w-[3rem] h-[3rem]"} src={images.logo} />
              <div className="pl-1 flex flex-col justify-center items-start">
                {(!isSupportedBrowser) ? 
                <div className={"flex flex-col"}>
                  <div className={""}>
                    {AppSVGStore.getSupportedBrowseres({size:30})}
                  </div>
                  <div className={`text-black text-left ${props.dsc.medium?"text-l":"text-xl"} font-bold`}>
                    {t(ELng.website_use_supported_browsers.valueOf())}
                  </div>
                </div>:
                  <div className={"flex flex-col text-black text-start"}>
                    <div>
                    {t(ELng.website_link_header.valueOf())}
                    </div>
                    <div className={"text-xl font-bold"}>
                      {t(ELng.website_link_desc.valueOf())}
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </>,
        f: (isSupportedBrowser) ? () => { window.open(Globals.webSiteUrl, "blank") } : (undefined)
      })}
    </div>
  </CardWrapper>
  )
}